import React from "react";
import {
  Award, ShieldCheck, Cpu, Zap, Home, Factory, House, Bot, Cctv, Wind,
  PlugZap, Wrench, Gauge, FlaskConical, Handshake, Target, TrendingUp,
} from "lucide-react";

const MAP = {
  Award, ShieldCheck, Cpu, Zap, Home, Factory, House, Bot, Cctv, Wind,
  PlugZap, Wrench, Gauge, FlaskConical, Handshake, Target, TrendingUp,
};

export const Icon = ({ name, className }) => {
  const C = MAP[name] || Zap;
  return <C className={className} />;
};
